<template>
  <nav class="navbar navbar-expand-lg shadow fixed-top nav-color px-3">
    <div class="container-fluid">
      <router-link
        class="nav-link"
        aria-current="page"
        to="/"
        @click="closeMenu"
      >
        <img src="@/assets/logo.png" class="logo" />
      </router-link>
      <button
        class="navbar-toggler"
        @click="toggleMenu"
        aria-controls="navbarNav"
        aria-expanded="false"
      >
        <i :class="menuOpen ? 'fa-solid fa-times' : 'fa-solid fa-water'"></i>
      </button>

      <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link
              class="nav-link"
              aria-current="page"
              to="/"
              @click="closeMenu"
            >
              Home
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              aria-current="page"
              to="/"
              @click="closeMenu"
            >
              Company
            </router-link>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Modules
            </a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" @click="activeTab('navTechnical')">
                  Technical
                </a>
              </li>
              <li>
                <a class="dropdown-item" @click="activeTab('navDryDocking')">
                  Dry Docking
                </a>
              </li>
              <li>
                <a class="dropdown-item" @click="activeTab('navProcurement')">
                  Procurement
                </a>
              </li>
              <li>
                <a class="dropdown-item" @click="activeTab('navCommercial')">
                  Commercial
                </a>
              </li>
              <li>
                <a class="dropdown-item" @click="activeTab('navAnalytics')">
                  Analytics
                </a>
              </li>
              <li>
                <a class="dropdown-item" @click="activeTab('navSafety')">
                  Safety
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              target="_blank"
              href="https://maritechsoftware.com/jobs"
            >
              Join Us
            </a>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/contact-page" @click="closeMenu">
              Contact
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { useRouter, useRoute } from "vue-router";

export default {
  data() {
    return {
      menuOpen: false,
    };
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    function activeTab(tabId) {
      if (route.name !== "HomeView") {
        router.push({ name: "HomeView" }).then(() => {
          triggerTabClick(tabId);
        });
      } else {
        triggerTabClick(tabId);
      }
    }

    function triggerTabClick(tabId) {
      document.getElementById(tabId).click();

      const targetDiv = document.getElementById("tabModuleView");
      targetDiv.scrollIntoView({ behavior: "smooth", block: "start" });
      targetDiv.focus();

      if (window.innerWidth < 992) {
        this.menuOpen = false;
        document.querySelector(".navbar-collapse").classList.remove("show");
      }
    }

    return {
      activeTab,
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      document.querySelector(".navbar-collapse").classList.toggle("show");
    },
    closeMenu() {
      if (window.innerWidth < 992) {
        this.menuOpen = false;
        document.querySelector(".navbar-collapse").classList.remove("show");
      }
    },
  },
};
</script>

<style scoped>
.logo {
  max-width: 150px;
}

.nav-color {
  background-color: #024caa;
}

.navbar-nav .nav-link {
  color: white;
  font-family: lato, sans-serif;
}

.navbar-toggler {
  color: white;
  border: none;
}

.navbar-toggler:focus {
  box-shadow: 0 0 0 0;
}

.navbar-nav .nav-link.active,
.navbar-nav .nav-link.show {
  color: white;
}

.dropdown-item {
  cursor: pointer;
}
</style>
